var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnatIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 53,
    width: 279,
    height: 38,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 241,
    width: 282,
    height: 37,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 301,
    width: 346,
    height: 15,
    rx: 7.5,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 332,
    width: 238,
    height: 15,
    rx: 7.5,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 147,
    width: 223,
    height: 37,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7656 53C118.798 53 142.134 68.342 153.01 90.5322H92.8086C76.6866 90.5322 63.6173 103.135 63.6172 118.681C63.6172 133.984 76.2811 146.435 92.0547 146.82L92.8086 146.83H153.009C142.133 169.02 118.798 184.361 91.7656 184.361C54.3397 184.361 24 154.955 24 118.681C24.0001 82.4063 54.3397 53.0002 91.7656 53Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.617 146.83C346.043 146.83 376.383 176.236 376.383 212.511C376.383 248.785 346.043 278.191 308.617 278.191C281.584 278.191 258.249 262.849 247.373 240.659H309.659V240.638C324.722 240.089 336.766 227.708 336.766 212.511C336.766 197.313 324.723 184.931 309.659 184.383V184.361H247.374C258.25 162.172 281.585 146.83 308.617 146.83Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnatIconBlack);
export default __webpack_public_path__ + "static/media/Snat_icon_black.0f59b6cd9e6d72e8f0ae0ef2b022a916.svg";
export { ForwardRef as ReactComponent };